import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=34ecc33c&"
var script = {}
import style0 from "./Template.vue?vue&type=style&index=0&id=34ecc33c&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ecc33c')) {
      api.createRecord('34ecc33c', component.options)
    } else {
      api.reload('34ecc33c', component.options)
    }
    module.hot.accept("./Template.vue?vue&type=template&id=34ecc33c&", function () {
      api.rerender('34ecc33c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/A2fIndex/Template.vue"
export default component.exports